export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4676.ef58ebf5.jpg";